<div class="card-type-selection">
  <div class="selection-header">
    <h1 class="title">Choose PitchCard Type</h1>
    <p class="subtitle">Two powerful ways to share your story - pick what works for you.</p>
  </div>

  <div class="card-options">
    <div
      *ngFor="let option of cardTypeOptions"
      class="card-option"
      [class.selected]="selectedType === option.type"
      (click)="selectCardType(option.tempType)">

      <h3 class="card-title">{{ option.title }}</h3>

      <div class="card-image">
        <img [src]="option.image" [alt]="option.title" />
      </div>

      <div class="card-content">
        <ul class="features">
          <li *ngFor="let feature of option.features">{{ feature }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
